import React from 'react';

const NotFound = () => <div>Whoooops ... nothing found here...</div>

export default NotFound;